import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import Services from '../views/Services.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Professional Web Development & Business Automation',
      description: 'Custom websites, AI automation & digital tools for UK businesses. Fast delivery in 2-3 weeks. From £499.',
      keywords: 'web development UK, business automation, custom websites, small business websites, affordable web design'
    }
  },
  {
    path: '/services',
    name: 'Services',
    component: Services,
    meta: {
      title: 'Web Development & Automation Services',
      description: 'Custom websites, AI automation, e-commerce, and business tools for UK businesses. Fast delivery in 2-3 weeks. From £499.',
      keywords: 'web development services, website design, e-commerce, booking system, business automation, SEO services'
    }
  },
  {
    path: '/services/:service',
    name: 'ServiceDetail',
    component: () => import('../views/ServiceDetail.vue'),
    meta: {
      title: 'Service Details - Digitly',
      description: 'Learn more about our services',
      keywords: 'services, web development, business solutions'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: 'About Digitly - UK Web Development Agency',
      description: 'Learn about Digitly, a professional web development agency helping UK businesses succeed online with custom websites and automation solutions.',
      keywords: 'about Digitly, web development agency UK, our team, web design company'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      title: 'Contact Us - Get a Free Quote',
      description: 'Contact Digitly for a free web development quote. We respond within 24 hours. Call +44 78 9751 3276 or fill out our contact form.',
      keywords: 'contact Digitly, free quote, web development enquiry, get in touch'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: {
      title: 'Page Not Found',
      description: 'The page you are looking for does not exist.',
      noIndex: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router
